<div class="chat-container" [class.comments]="commentsUI" [ngStyle]="{ height: fullHeight ? '100%' : height ? height + 'px' : null }">
  <ul class="messages" #chatWindow>
    @for (msg of messages; track msg) {
      <li>
        @if (participants && participants.length && participantMap[msg.user_id]) {
          <div class="msg-container" [class.me]="msg.user_id == user.id" [class.them]="msg.user_id != user.id">
            <img [src]="participantMap[msg.user_id].photo || './assets/images/default_avatar.jpg'" class="profile-photo" />
            <div class="msg">
              <div class="text" [innerHTML]="msg.htmlMessage | safe: 'html'"></div>
              <span class="timestamp d-block">
                {{ msg.created.toDate() | date: "MMM Do hh:mma" : true }}
                @if (msg.user_id != user.id) {
                  <span>&nbsp;{{ participantMap[msg.user_id].name }}</span>
                }
                @if (msg.edited) {
                  <span class="c-gray">&nbsp;{{ "com.edited" | translate }}&nbsp;&nbsp;</span>
                }
                <div>
                  @if (msg.user_id == user.id || admin) {
                    <button class="msg-options-link" (click)="msgOptions(msg)">&nbsp;{{ "sphere.options" | translate }}</button>
                  }
                </div>
              </span>
            </div>
          </div>
        }
        @if (commentsUI) {
          <myp-comment
            [comment]="msg"
            [replies]="parentThreadMap[msg.key]"
            [sendOnEnter]="sendOnEnter"
            (flagged)="flagComment($event)"
            (unflagged)="unflagComment($event)"
            (liked)="likeComment($event)"
            (replied)="sendReply($event)"
            (editMessageClicked)="editComment($event)"
            (deleteMessageClicked)="deleteComment($event)"
            (flagCleared)="clearFlag($event)"
            (adminDeleteMessageClicked)="adminDeleteComment($event)"
            [forceDark]="forceDark"
          ></myp-comment>
        }
      </li>
    }
    @if (commentsUI && !messages.length) {
      <span [class.c-white]="forceDark" style="display: flex; align-items: center; height: 100%; text-align: center; justify-content: center">{{ "com.no_comments_yet" | translate }}</span>
    }
  </ul>
  @if (previewMessage) {
    <div class="new-message-preview" [class.visible]="previewMessageVisible" (click)="onPreviewClicked()">
      <img [src]="previewMessage.author?.photo || './assets/images/default_avatar.jpg'" class="preview-photo" alt="" />
      <div class="preview-content">
        <span class="preview-name">{{ previewMessage.author?.name }}</span>
        <span class="preview-text" [innerHTML]="previewMessage.htmlMessage | safe: 'html'"></span>
      </div>
    </div>
  } @else if (showNewMessagesIndicator) {
    <div class="new-messages-indicator" (click)="scrollChatToBottom(true)">New Messages</div>
  }
  <div class="input-container text-left">
    <div class="msg-input">
      <myp-message-input
        #msgInput
        [type]="'span'"
        inputID="main-input"
        [mentionSource]="mentionDataSource ? true : false"
        [mentionDataSource]="mentionDataSource"
        [shouldDetectContent]="commentsUI"
        (valueChanged)="messageValueChange($event)"
        (returnPressed)="sendMessage($event)"
        [sendOnEnter]="sendOnEnter"
        [placeholder]="(commentsUI ? (sendOnEnter ? 'com.enter_to_send' : 'com.ctrl_enter_to_send') : 'com.enter_a_message') | translate"
        [includeSendButton]="true"
        [textSendButton]="true"
        ariaLabelBy="comment-label"
      ></myp-message-input>
    </div>
  </div>
</div>
